import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import {
  sortMovementTypeLabels,
  type TMovementType,
  type TMovementTypeGroup,
  type IMovementType,
  type IMovementTypeGroup,
  useMovementTypes,
} from '@/entities/movement-type';
import type ru from '../../i18n/ru.json';
import { useComponentI18n } from '@/shared/composables/useComponentI18n';

type TSchema = typeof ru;

export function useExcursionFilterMovementTitle(messages: TSchema) {
  const { t } = useComponentI18n({ ru: messages });

  const filtersStore = useExcursionFiltersStore();
  const movementTypes = useMovementTypes();

  const isActive = computed(() => !!filtersStore.searchState.movementTypes?.length);

  const title = computed(() => {
    const selected = filtersStore.searchState.movementTypes;

    if (!selected?.length) {
      return t('movement.title');
    }

    return sortMovementTypeLabels(filtersStore.searchState.movementTypes as Array<TMovementType | TMovementTypeGroup>, [
      ...(movementTypes.movementTypes.value as IMovementType[]),
      ...(movementTypes.movementTypeGroups.value as IMovementTypeGroup[]),
    ]);
  });

  const itemsCount = computed(() => filtersStore.searchState.movementTypes?.length ?? 0);

  return {
    title,
    itemsCount,
    isActive,
  };
}
